var fn = {
  type: function type(val) {
    return val && {}.toString.call(val) === '[object Function]';
  },
  result: function result(val, obj) {
    return obj.toBe.test(val(obj.of));
  }
};
module.exports = fn;